<template>
    <transition name="fadeoutTransitionVideos">
        <div id="TransitionVideos" v-if="videoQueue.length > 0">
            <video v-for="video in playingVideo" :key="video.id" :poster="video.poster" @ended="removeFromQueue" autoplay playsinline webkit-playsinline muted>
                <source :src="video.src">
            </video>
            <button class="TransitionVideos__skipbutton" v-if="isVideoskippable" @click="removeFromQueue">SKIP</button>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            transitions: [],
            videoQueue: []
        }
    },
    created() {
        this.transitions = this.$store.getters.getVideoTransitions;
    },
    mounted() {
        this.populateVideoQueue(null, app.api.PageManager.getCurrentRoute(), true)
    },
    watch: {
        $route(to, from) {
            let toPath = to.fullPath;
            let fromPath = from.fullPath;
            this.populateVideoQueue(fromPath, toPath, false)
        },
        playingVideo() {
            let queueLength = this.videoQueue.length;
            if(queueLength > 0) {
                this.$store.commit('disableNavigation');
            } else {
                this.$store.commit('enableNavigation');
            }
        }
    },
    methods: {
        populateVideoQueue(from, to, isInitialLoad) {
            for(let i = 0; i < this.transitions.length; i++) {
                if((this.transitions[i].from == from || isInitialLoad) && this.transitions[i].to == to) {
                    let video = {
                        id: this.transitions[i].id,
                        src: app.api.Utils.getMediaPath(this.transitions[i].transitionVideo.src),
                        poster: app.api.Utils.getMediaPath(this.transitions[i].transitionPoster.src),
                        skippable: this.transitions[i].skippable
                    }
                    this.videoQueue.push(video);
                } 
            }
        },
        removeFromQueue() {
            this.videoQueue.shift()
        }
    },
    computed: {
        playingVideo() { 
            let video = [this.videoQueue[0]];
            return video;
        },
        isVideoskippable() {
            return this.videoQueue[0].skippable
        }
    }
}
</script>

<style lang="scss">
#TransitionVideos {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    &>video {
        width: 100%;
        height: 100%;
    }
    
    .TransitionVideos__skipbutton {
        position: absolute;
        height: 45px;
        padding: 0 14px;
        right: 40px;
        bottom: 40px;
        color: var(--main-color);
        background: var(--secondary-color);
        border-radius: 1000px;
        box-shadow: var(--shadow-medium);
        transition-property: color, background;
        transition-duration: 0.2s;
        transition-timing-function: var(--tk-easeinout);

        &:hover{
            background: var(--main-color);
            color: var(--secondary-color);
        }
    }
}

.fadeoutTransitionVideos-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
  transition-timing-function: ease;
}

.fadeoutTransitionVideos-leave-to {
    opacity: 0;
}
</style>